// extracted by css-extract-rspack-plugin
export default {"wrapper":"HeaderCellWrapper_wrapper__SRILJ"};